import { MetaSiteSearchEntry } from '@wix/ambassador-metasite-search-v2-search-entry/types'
import { removeQueryParams } from '@wix/funnel-utils'

type SpaceConfig = {
  getProjectName: () => string
  getMetaSiteLink: (metaSite: MetaSiteSearchEntry, flowId?: string) => string
}

export const spaceConfigs: Record<string, SpaceConfig> = {
  // intro react
  'caf2f2de-c140-4e4c-a7ea-57cd9b87cafc': {
    getProjectName: () => 'Wix Intro (React)',
    getMetaSiteLink: (metaSite, flowId) => {
      return `https://wix.com/_api/funnel-intro-router-service/preview/${flowId}${window.location.search}&metaSiteId=${metaSite.metaSiteId}`
    },
  },
  default: {
    getProjectName: () => 'funnel-intro-unified',
    getMetaSiteLink: (metaSite, flowId = '3e8f87aa-ec04-4004-aa4d-389178f6b05c') => {
      const flowSlugMap: Record<string, string> = {
        '3e8f87aa-ec04-4004-aa4d-389178f6b05c': 'unified',
        '2cc30b98-f961-4694-8107-eb1da010a7fc': 'unified_test',
        'd6e242b4-8537-4590-a650-dbaf0cb92bc2': 'second_site',
        '44cdd174-052b-42ca-b970-7fa00b5bd6cf': 'unified_international',
      }
      const url = `https://manage.wix.com/dashboard/${metaSite.metaSiteId}/funnel-intro-unified/preview${window.location.search}&introModal=unified&flowSlug=${flowSlugMap[flowId]}`
      return removeQueryParams(url, ['flowId', 'spaceId'])
    },
  },
}
